







































import { Component, Ref, Prop, Vue } from "vue-property-decorator";
import { ElForm } from "element-ui/types/form";
import { Item } from "@/types/list";
import { sleep } from "@/utils";

@Component({
  components: {},
})
export default class Add extends Vue {
  @Prop(Function) dialogClose!: () => void;
  @Prop(Function) edite!: (param: Item) => void;
  @Prop(Object) currentRow!: Item;
  @Ref("form") readonly formEle!: ElForm;
  loading = false;
  dialogVisible = true;
  addForm = {
    desc: this.currentRow.desc,
    name: this.currentRow.name,
  };
  formRule = {
    name: [
      {
        required: true,
        message: "请输入规则名称",
        trigger: ["change", "blur"],
      },
    ],
    desc: [
      {
        required: true,
        message: "请输入描述",
        trigger: ["change", "blur"],
      },
    ],
  };
  handleClose(): void {
    this.dialogVisible = false;
    this.dialogClose();
  }
  resetForm(): void {
    this.formEle.resetFields();
  }
  submit(): void {
    this.formEle.validate(async (res) => {
      if (res) {
        this.loading = true;
        await sleep(1000);
        this.handleClose();
        this.edite({ ...this.currentRow, ...this.addForm });
      }
      this.loading = false;
    });
  }
}
